<mat-list>
  <div class="header">
    {{dienst.getLabel()}}: {{category.getLabel() | lowercase}}
  </div>
  <div class="fade-out"></div>
  @for (taak of taken; track taak) {
    <mat-list-item>
      <span matListItemAvatar [ngClass]="taak.getIcoon()"></span>
      <div matListItemTitle>{{taak.getLabel()}}</div>
      @if (prestatie) {
        <div matListItemLine class="mat-small frequentie">Uitgevoerd om {{getUitgevoerdeTaak(taak).getTijdstip() | date:'HH:mm'}}</div>
      }
      <div matListItemLine class="mat-small tips"><span (click)="onOpenTips(taak)">Toon tips {{getTipAantal(taak)}}</span></div>
    </mat-list-item>
  }
</mat-list>
